












































import {Component, Prop, Vue} from "vue-property-decorator";
import InstrTmpl from "@/module/instr/InstrTmpl";

@Component({})
export default class InstrTmplItem extends Vue {
  @Prop()
  tmpl!: InstrTmpl
}
